import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69f9b679f6558f001487e183/uyir/src/app/sign-up-login-screen/components/AuthScreen.tsx");
